import './Buy.css';
import React from "react";
import Container from '../container';

function Buy() {
    return (
       <div className='buy_container'>
        <Container/>
       </div>
    );
}

export default Buy;